var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { appStore } from "../state/store";
export class EmotionalTranslator {
    constructor(app) {
        this.app = app;
        this.isLoading = false;
        this.translatedText = "";
        const firstPartner = appStore.getState().team.find(p => p.role !== 'leader');
        this.selectedPartnerUuid = firstPartner ? firstPartner.uuid : '';
    }
    handleTranslate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            this.translatedText = "";
            this.app.renderCurrentView(); // Renders the loader state
            const inputText = document.getElementById('translator-input').value;
            const { team, knowledgeGraph, premiumState } = appStore.getState();
            const targetPartner = team.find(p => p.uuid === this.selectedPartnerUuid);
            if (!targetPartner) {
                this.translatedText = "<p class='error'>Error: Selected partner not found.</p>";
                this.isLoading = false;
                this.app.renderCurrentView(); // Renders the error state
                return;
            }
            // *** START OF MODIFICATION ***
            // 1. Get Observed Behavior (Archetype) from the demo data
            const actorFingerprint = premiumState.multiScalarAnalyticalRepresentations.actorFingerprints[targetPartner.uuid];
            const observedBehavior = actorFingerprint ? actorFingerprint.archetypeInsight.split("'")[1] : "Unknown"; // Extracts 'Giver', 'Blocker', etc.
            // 2. Perform Psychological Inference using the Knowledge Graph
            const bfi = targetPartner.profile.bfiProfile;
            const traits = Object.keys(bfi);
            const sortedTraits = traits.sort((a, b) => bfi[b] - bfi[a]);
            const dominantTraitId = sortedTraits[0];
            const dominantTraitInfo = knowledgeGraph[dominantTraitId];
            // For a 'Blocker' archetype, we might infer 'Fear of Failure' if they are high in Neuroticism
            let psychologicalDriver = "A general communication adjustment.";
            if (observedBehavior === 'Blocker' && dominantTraitId === 'neuroticism') {
                psychologicalDriver = dominantTraitInfo.disadvantages.fearOfFailureLeadingToAvoidance.name;
            }
            // (This logic could be expanded for other archetypes)
            // 3. Get Communication Strategy from Knowledge Graph
            const communicationStrategy = dominantTraitInfo.communicationPreferences;
            // 4. Find the Highest-Impact Intervention Habit
            let interventionHabit = null;
            if (observedBehavior === 'Blocker' && dominantTraitId === 'neuroticism') {
                // Traverse the knowledge graph to find the mitigator
                const disadvantage = dominantTraitInfo.disadvantages.fearOfFailureLeadingToAvoidance;
                // This logic assumes Conscientiousness is the desired mitigator. It could be made more dynamic.
                interventionHabit = disadvantage.mitigatingTraits.conscientiousness.implementations[0];
            }
            // (Provide a default if none is found)
            if (!interventionHabit) {
                interventionHabit = knowledgeGraph.conscientiousness.disadvantages.perfectionismLeadingToStress.mitigatingTraits.openness.implementations[0];
            }
            const strategicContext = {
                observedBehavior,
                psychologicalDriver,
                communicationStrategy,
                interventionHabit // Add the new habit object to the context
            };
            try {
                const API_URL = process.env.API_BASE_URL;
                const response = yield fetch(`${API_URL}/api/translate-emotionally`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        message: inputText,
                        targetProfile: targetPartner.profile.bfiProfile,
                        targetName: targetPartner.name,
                        strategicContext: strategicContext
                    }),
                });
                if (!response.ok)
                    throw new Error(`AI translation failed with status ${response.status}`);
                const data = yield response.json();
                this.translatedText = data.translation;
            }
            catch (error) {
                console.error(error);
                this.translatedText = "<p class='error'>Error: Could not connect to the AI service.</p>";
            }
            finally {
                this.isLoading = false;
                this.app.renderCurrentView(); // Renders the final result/error state
            }
        });
    }
    render() {
        const { team } = appStore.getState();
        const partners = team.filter(m => m.role !== 'leader');
        const partnerOptions = partners.map(p => `<option value="${p.uuid}" ${this.selectedPartnerUuid === p.uuid ? 'selected' : ''}>${p.name}</option>`).join('');
        const selectedPartner = team.find(p => p.uuid === this.selectedPartnerUuid);
        const bfi = selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.profile.bfiProfile;
        let resultSection = "";
        if (this.isLoading) {
            resultSection = `<div class="loader-small"></div><p>Rhetorical Engine is computing...</p>`;
        }
        else if (this.translatedText) {
            resultSection = `
                <h4>Translated Message:</h4>
                <div class="translated-output">${this.translatedText}</div>
            `;
        }
        return `
            <div class="translator-container">
                <h3>The Rhetorical Engine</h3>
                <p>This is a <strong>Computational</strong> tool for strategic <strong>Communication</strong>. Select a target and the system will translate your message to resonate with their unique psychological profile.</p>
                <div class="form-group">
                    <label for="partner-select">Select Target:</label>
                    <select id="partner-select">${partnerOptions}</select>
                </div>
                <p class="profile-summary"><strong>Selected Profile:</strong> O:${bfi === null || bfi === void 0 ? void 0 : bfi.openness}, C:${bfi === null || bfi === void 0 ? void 0 : bfi.conscientiousness}, E:${bfi === null || bfi === void 0 ? void 0 : bfi.extraversion}, A:${bfi === null || bfi === void 0 ? void 0 : bfi.agreeableness}, N:${bfi === null || bfi === void 0 ? void 0 : bfi.neuroticism}</p>
                <textarea id="translator-input" placeholder="Enter your core message here...">We need to accelerate the 'Phoenix' project timeline. It's behind schedule.</textarea>
                <div class="button-container">
                    <button id="translate-button" class="button-primary" ${this.isLoading ? 'disabled' : ''}>Translate</button>
                </div>
                <div id="translator-result" class="translator-result">
                    ${resultSection}
                </div>
            </div>
        `;
    }
    attachEventListeners() {
        var _a, _b;
        (_a = document.getElementById('translate-button')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.handleTranslate();
        });
        (_b = document.getElementById('partner-select')) === null || _b === void 0 ? void 0 : _b.addEventListener('change', (e) => {
            this.selectedPartnerUuid = e.target.value;
            this.app.renderCurrentView(); // Trigger parent re-render to update profile summary
        });
    }
}
